export const GET_ALL_ORDERS = "get/all/orders";
export const UPDATE_ORDERS = "update/orders";
export const DELETE_ORDERS = "delete/orders";
export const LOADING_ORDERS = "loading/orders";
export const ERROR_ORDERS = "error/orders";
export const RESET_ORDERS = "reset/orders";
